import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ExpandableTable } from "@ploy-ui/core";
import { Box, useMediaQuery, TablePagination } from "@material-ui/core";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { messages } from "../messages";
import { useMemo, useState } from "react";
import { formatApplicationNumber } from "../utils/formatApplicationNumber";
const BuyoutApplications = (props) => {
    const { applications } = props;
    const navigate = useNavigate();
    const intl = useIntl();
    const isMobile = useMediaQuery("(max-width:600px)");
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(20);
    const recordCount = applications?.length ?? 0;
    const handleChangePage = (_event, newPage) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event) => {
        const newSize = parseInt(event?.target?.value ?? pageSize, 10) || pageSize;
        setPageSize(newSize);
        setPage(0);
    };
    const columnData = useMemo(() => [
        {
            id: "AccountNumber",
            label: intl.formatMessage(messages.applicationNumber),
            component: props => (_jsx(Box, { children: formatApplicationNumber(props.rowData["AccountNumber"]) })),
            hidden: isMobile
        },
        {
            id: "CustomerName",
            label: intl.formatMessage(messages.listCustomerName),
            component: props => (_jsxs(_Fragment, { children: [_jsx(Box, { fontWeight: "bold", children: props.rowData["CustomerName"] }), _jsx(Box, { children: isMobile &&
                            formatApplicationNumber(props.rowData["AccountNumber"]) }), _jsx(Box, { children: isMobile && props.rowData["ObjectSerialNumber"] })] }))
        },
        {
            id: "MakeModel",
            label: intl.formatMessage(messages.makeModel),
            hidden: isMobile
        },
        {
            id: "ObjectSerialNumber",
            label: intl.formatMessage(messages.chassiOrRegNumber),
            hidden: isMobile
        },
        {
            id: "StartDate",
            label: intl.formatMessage(messages.startDate),
            component: props => (_jsxs(_Fragment, { children: [_jsx(Box, { children: props.rowData["StartDate"] }), _jsx(Box, { children: isMobile && props.rowData["EndDate"] }), _jsx(Box, { children: isMobile && props.rowData["RemainingTerms"] })] }))
        },
        {
            id: "EndDate",
            label: intl.formatMessage(messages.endDate),
            hidden: isMobile
        },
        {
            id: "RemainingTerms",
            label: intl.formatMessage(messages.timeLeft),
            component: props => (_jsxs(Box, { children: [props.rowData["RemainingTerms"], " terminer"] })),
            hidden: isMobile
        },
        {
            id: "SellerName",
            label: intl.formatMessage(messages.salespersonName),
            component: props => (_jsx(_Fragment, { children: _jsx(Box, { children: props.rowData["SellerName"] }) }))
        }
    ], [isMobile, intl]);
    const tableData = useMemo(() => applications ?? [], [applications]);
    return (_jsxs(Box, { style: {
            left: "10%",
            right: "10%"
        }, children: [_jsx(ExpandableTable, { idColumn: "AccountNumber", tableData: tableData, columnData: columnData, expandable: false, tableIsSortable: true, pagination: { page, rowsPerPage: pageSize }, onRowClick: row => navigate(row.AccountNumber) }), _jsx(TablePagination, { rowsPerPageOptions: [10, 20, 50], component: "div", count: recordCount, rowsPerPage: pageSize, page: page, onPageChange: handleChangePage, onRowsPerPageChange: handleChangeRowsPerPage, labelRowsPerPage: intl.formatMessage(messages.rowsPerPage) })] }));
};
export { BuyoutApplications };
//# sourceMappingURL=BuyoutApplications.js.map